export const UPDATE_SEARCH_KEYWORDS = "UPDATE_SEARCH_KEYWORDS";
export const updateSearchKeywordsAction = (text) => {
    //console.trace(text);
    return {
        type: "UPDATE_SEARCH_KEYWORDS",
        payload: text
    }
}

